import { useState } from "react";
import { useContractRead } from "wagmi";
import { _isNotEmptyNftId, _no, _notEmpty } from "../utils";
import { ERROR_NFTIDS } from "../utils/config";
import { useSelector } from "react-redux";

const usePositionNFT = ({
    config,
    data,
    isNftId = false
}) => {

    const [result, setResult] = useState(null);
    const { chainId, positionNFTContract } = config;

    const functionName = isNftId
        ? "ownerOf"
        : "walletOfOwner";

    const savedNftId = useSelector(
        (state) => state.settings.nftId
    );

    const enabled = _notEmpty(data)
        && _notEmpty(chainId)
        && _notEmpty(positionNFTContract?.address);

    const watchContract = _no(
        _isNotEmptyNftId(savedNftId)
    );

    const allNfttPositions = useContractRead({
        chainId,
        address: positionNFTContract?.address,
        abi: positionNFTContract?.abi,
        functionName,
        args: [
            data
        ],
        enabled,
        watch: watchContract,
        onError: (error) => {
            console.error(
                ERROR_NFTIDS,
                error
            );

            setResult(-1);
        },
        onSuccess: (response) => {
            if (_no(isNftId)) {
                setResult(response.length ? Number(response[0]) : -1);
            } else {
                setResult(response);
            }
        },
    });

    return {
        result,
        isFetching: allNfttPositions.isFetching
    };
};

export default usePositionNFT;
